export type ToastVariant = 'success' | 'error' | 'warning' | 'info'

export type ToastOptions = {
  toastId?: string | number
}

export type ToastPayload = {
  id: string | number
  variant: ToastVariant
  message: string
}

type ToastListener = (payload: ToastPayload) => void

const AUTO_DISMISS_MS = 4500

let nextNumericId = 1
const listeners = new Set<ToastListener>()

export function subscribeToToasts(listener: ToastListener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function emit(variant: ToastVariant, message: string, options?: ToastOptions) {
  const id = options?.toastId ?? nextNumericId++
  const payload: ToastPayload = { id, variant, message }
  listeners.forEach(listener => listener(payload))
}

export const toast = {
  success(message: string, options?: ToastOptions) {
    emit('success', message, options)
  },
  error(message: string, options?: ToastOptions) {
    emit('error', message, options)
  },
  warning(message: string, options?: ToastOptions) {
    emit('warning', message, options)
  },
  info(message: string, options?: ToastOptions) {
    emit('info', message, options)
  },
}

export { AUTO_DISMISS_MS }
